import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "box form" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = {
  class: "column is-5",
  role: "form",
  "aria-label": "Formulário para criação de uma nova tarefa"
}
const _hoisted_4 = { class: "column is-3" }
const _hoisted_5 = { class: "select" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Selecione o Projeto", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Temporizador = _resolveComponent("Temporizador")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "input",
          placeholder: "Qual tarefa você deseja iniciar",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.descricaoTarefa) = $event))
        }, null, 512), [
          [_vModelText, _ctx.descricaoTarefa]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.idProjeto) = $event))
          }, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projetos, (projeto) => {
              return (_openBlock(), _createElementBlock("option", {
                value: projeto.id,
                key: projeto.id
              }, _toDisplayString(projeto.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.idProjeto]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Temporizador, { onTemporizadorFinalizado: _ctx.finalizarTarefaData }, null, 8, ["onTemporizadorFinalizado"])
      ])
    ])
  ]))
}